import { combineReducers } from 'redux';
import { reducer as logInUserReducer } from '@routes/LogIn/modules/module';
import { reducer as uploadProgressReducer } from '@routes/LogIn/modules/uploadProgressModule';

const initReducers = {
	logInData: logInUserReducer,
	uploadProgress: uploadProgressReducer,
};

export const createReducers = (asyncReducers = {}) => {
	return combineReducers({
		...initReducers,
		...asyncReducers,
	});
};
